import React from 'react';
import { NextPage } from 'next';
// Hocks
import withApollo from 'hocs/withApollo';
// Layouts
import Head from 'layouts/Head/Head';
import Header from 'layouts/Header/Header';
import Footer from 'layouts/Footer/Footer';
// Components
import { Banner, OurProducts, CTA, OurTeam } from 'components/AboutUs';

const AboutUs: NextPage = () => {
  return (
    <>
      <Head
        title="About Us"
        description="Make money and connect with MILLIONS of fans"
      />
      <Header />
      <Banner />
      <OurProducts />
      <CTA />
      <OurTeam />
      <Footer />
    </>
  );
};

export default withApollo(AboutUs);
